import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';

const EvaluationList = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useApp();
  const [evaluations, setEvaluations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    search: '',
    type: 'todos',
    project: 'todos',
    course: 'todos',
    status: 'todos'
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    loadEvaluations();
  }, []);

  const loadEvaluations = async () => {
    try {
      setLoading(true);

      // Mock data - aquí se haría la llamada real a la API
      const mockEvaluations = [
        // Proyecto 1: Ecosistemas Marinos de Chile
        {
          id: 'eval-1',
          projectId: 1,
          projectName: 'Ecosistemas Marinos de Chile',
          courses: ['7° Básico A', '7° Básico B'],
          type: 'subject',
          evaluationName: 'Ciencias Naturales',
          subjectId: 'science-001',
          teacherName: 'María José Rodríguez',
          totalStudents: 58,
          evaluatedStudents: 45,
          totalIndicators: 8,
          configuredIndicators: 8,
          hasRubric: true,
          status: 'en_progreso'
        },
        {
          id: 'eval-2',
          projectId: 1,
          projectName: 'Ecosistemas Marinos de Chile',
          courses: ['7° Básico A', '7° Básico B'],
          type: 'subject',
          evaluationName: 'Matemáticas',
          subjectId: 'math-001',
          teacherName: 'Pedro Santander',
          totalStudents: 58,
          evaluatedStudents: 58,
          totalIndicators: 6,
          configuredIndicators: 6,
          hasRubric: true,
          status: 'completada'
        },
        {
          id: 'eval-3',
          projectId: 1,
          projectName: 'Ecosistemas Marinos de Chile',
          courses: ['7° Básico A', '7° Básico B'],
          type: 'subject',
          evaluationName: 'Lenguaje',
          subjectId: 'lang-001',
          teacherName: 'Laura Mendoza',
          totalStudents: 58,
          evaluatedStudents: 52,
          totalIndicators: 5,
          configuredIndicators: 5,
          hasRubric: true,
          status: 'en_progreso'
        },
        {
          id: 'eval-4',
          projectId: 1,
          projectName: 'Ecosistemas Marinos de Chile',
          courses: ['7° Básico A', '7° Básico B'],
          type: 'self-evaluation',
          evaluationName: 'Autoevaluación',
          subjectId: 'general-self',
          totalStudents: 58,
          evaluatedStudents: 0,
          totalIndicators: 6,
          configuredIndicators: 4,
          hasRubric: false,
          status: 'pendiente'
        },
        {
          id: 'eval-5',
          projectId: 1,
          projectName: 'Ecosistemas Marinos de Chile',
          courses: ['7° Básico A', '7° Básico B'],
          type: 'co-evaluation',
          evaluationName: 'Coevaluación',
          subjectId: 'general-co',
          totalStudents: 58,
          evaluatedStudents: 30,
          totalIndicators: 5,
          configuredIndicators: 5,
          hasRubric: true,
          status: 'en_progreso'
        },
        // Proyecto 2: Historia Viva: Chile en el Siglo XX
        {
          id: 'eval-6',
          projectId: 2,
          projectName: 'Historia Viva: Chile en el Siglo XX',
          courses: ['8° Básico A', '8° Básico C'],
          type: 'subject',
          evaluationName: 'Historia',
          subjectId: 'history-001',
          teacherName: 'Roberto Fuentes',
          totalStudents: 54,
          evaluatedStudents: 0,
          totalIndicators: 7,
          configuredIndicators: 3,
          hasRubric: false,
          status: 'pendiente'
        },
        {
          id: 'eval-7',
          projectId: 2,
          projectName: 'Historia Viva: Chile en el Siglo XX',
          courses: ['8° Básico A', '8° Básico C'],
          type: 'subject',
          evaluationName: 'Lenguaje',
          subjectId: 'lang-002',
          teacherName: 'Laura Mendoza',
          totalStudents: 54,
          evaluatedStudents: 0,
          totalIndicators: 5,
          configuredIndicators: 2,
          hasRubric: false,
          status: 'pendiente'
        },
        {
          id: 'eval-8',
          projectId: 2,
          projectName: 'Historia Viva: Chile en el Siglo XX',
          courses: ['8° Básico A', '8° Básico C'],
          type: 'self-evaluation',
          evaluationName: 'Autoevaluación',
          subjectId: 'general-self-2',
          totalStudents: 54,
          evaluatedStudents: 0,
          totalIndicators: 8,
          configuredIndicators: 0,
          hasRubric: false,
          status: 'pendiente'
        },
        // Proyecto 3: Emprendimiento Sostenible
        {
          id: 'eval-9',
          projectId: 3,
          projectName: 'Emprendimiento Sostenible',
          courses: ['1° Medio A'],
          type: 'subject',
          evaluationName: 'Matemáticas',
          subjectId: 'math-002',
          teacherName: 'Pedro Santander',
          totalStudents: 32,
          evaluatedStudents: 32,
          totalIndicators: 6,
          configuredIndicators: 6,
          hasRubric: true,
          status: 'completada'
        },
        {
          id: 'eval-10',
          projectId: 3,
          projectName: 'Emprendimiento Sostenible',
          courses: ['1° Medio A'],
          type: 'subject',
          evaluationName: 'Ciencias Naturales',
          subjectId: 'science-002',
          teacherName: 'María José Rodríguez',
          totalStudents: 32,
          evaluatedStudents: 28,
          totalIndicators: 5,
          configuredIndicators: 5,
          hasRubric: true,
          status: 'en_progreso'
        },
        {
          id: 'eval-11',
          projectId: 3,
          projectName: 'Emprendimiento Sostenible',
          courses: ['1° Medio A'],
          type: 'subject',
          evaluationName: 'Tecnología',
          subjectId: 'tech-001',
          teacherName: 'Diego Torres',
          totalStudents: 32,
          evaluatedStudents: 25,
          totalIndicators: 7,
          configuredIndicators: 7,
          hasRubric: true,
          status: 'en_progreso'
        },
        {
          id: 'eval-12',
          projectId: 3,
          projectName: 'Emprendimiento Sostenible',
          courses: ['1° Medio A'],
          type: 'self-evaluation',
          evaluationName: 'Autoevaluación',
          subjectId: 'general-self-3',
          totalStudents: 32,
          evaluatedStudents: 32,
          totalIndicators: 8,
          configuredIndicators: 8,
          hasRubric: true,
          status: 'completada'
        },
        {
          id: 'eval-13',
          projectId: 3,
          projectName: 'Emprendimiento Sostenible',
          courses: ['1° Medio A'],
          type: 'co-evaluation',
          evaluationName: 'Coevaluación',
          subjectId: 'general-co-3',
          totalStudents: 32,
          evaluatedStudents: 30,
          totalIndicators: 6,
          configuredIndicators: 6,
          hasRubric: true,
          status: 'en_progreso'
        }
      ];

      setEvaluations(mockEvaluations);
    } catch (error) {
      showError('Error al cargar las evaluaciones');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
    setCurrentPage(1); // Reset a la primera página al cambiar filtros
  };

  const filteredEvaluations = evaluations.filter(evaluation => {
    const searchLower = filters.search.toLowerCase();

    // Búsqueda en todas las columnas excepto progreso
    const matchesSearch = filters.search === '' || (
      evaluation.projectName.toLowerCase().includes(searchLower) ||
      evaluation.evaluationName.toLowerCase().includes(searchLower) ||
      evaluation.teacherName?.toLowerCase().includes(searchLower) ||
      evaluation.courses?.some(course => course.toLowerCase().includes(searchLower)) ||
      getEvaluationType(evaluation.type).label.toLowerCase().includes(searchLower) ||
      getStatusText(evaluation.status).toLowerCase().includes(searchLower)
    );

    const matchesType = filters.type === 'todos' || evaluation.type === filters.type;
    const matchesProject = filters.project === 'todos' || evaluation.projectId === filters.project;
    const matchesCourse = filters.course === 'todos' || evaluation.courses?.includes(filters.course);
    const matchesStatus = filters.status === 'todos' || evaluation.status === filters.status;

    return matchesSearch && matchesType && matchesProject && matchesCourse && matchesStatus;
  });

  // Paginación
  const totalPages = Math.ceil(filteredEvaluations.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedEvaluations = filteredEvaluations.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completada':
        return 'Completada';
      case 'en_progreso':
        return 'En Progreso';
      case 'pendiente':
        return 'Pendiente';
      default:
        return status;
    }
  };

  const getEvaluationType = (type) => {
    switch (type) {
      case 'subject':
        return { label: 'Asignatura', color: 'bg-blue-100 text-blue-800' };
      case 'self-evaluation':
        return { label: 'Autoevaluación', color: 'bg-indigo-100 text-indigo-800' };
      case 'co-evaluation':
        return { label: 'Coevaluación', color: 'bg-purple-100 text-purple-800' };
      default:
        return { label: type, color: 'bg-gray-100 text-gray-800' };
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'completada':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Completada</span>;
      case 'en_progreso':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">En Progreso</span>;
      case 'pendiente':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">Pendiente</span>;
      default:
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">{status}</span>;
    }
  };

  const handleExecuteEvaluation = (evaluation) => {
    if (evaluation.type === 'subject') {
      navigate(`/projects/${evaluation.projectId}/subjects/${evaluation.subjectId}/execute`);
    } else {
      // Para autoevaluación y coevaluación, usar la ruta con subjectId y evaluationType
      navigate(`/projects/${evaluation.projectId}/subjects/${evaluation.subjectId}/${evaluation.type}/execute`);
    }
  };

  const handleConfigureEvaluation = (evaluation) => {
    if (evaluation.type === 'subject') {
      navigate(`/projects/${evaluation.projectId}/subjects/${evaluation.subjectId}/evaluation`);
    } else {
      // Para autoevaluación y coevaluación, usar la ruta con subjectId y evaluationType
      navigate(`/projects/${evaluation.projectId}/subjects/${evaluation.subjectId}/${evaluation.type}/config`);
    }
  };

  const handleViewProject = (projectId) => {
    navigate(`/projects/${projectId}`);
  };

  // Obtener lista única de proyectos para el filtro
  const uniqueProjects = [...new Map(evaluations.map(e => [e.projectId, { id: e.projectId, name: e.projectName }])).values()];

  // Obtener lista única de cursos para el filtro
  const uniqueCourses = [...new Set(evaluations.flatMap(e => e.courses || []))].sort();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Evaluaciones</h1>
          <p className="text-gray-600">Gestiona todas las evaluaciones de tus proyectos ABP</p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {/* Search */}
          <div>
            <label htmlFor="search" className="block text-sm font-medium text-gray-700 mb-1">
              Buscar
            </label>
            <input
              type="text"
              id="search"
              name="search"
              value={filters.search}
              onChange={handleFilterChange}
              placeholder="Proyecto, curso, profesor..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>

          {/* Type filter */}
          <div>
            <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
              Tipo de Evaluación
            </label>
            <select
              id="type"
              name="type"
              value={filters.type}
              onChange={handleFilterChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="todos">Todos los tipos</option>
              <option value="subject">Asignatura</option>
              <option value="self-evaluation">Autoevaluación</option>
              <option value="co-evaluation">Coevaluación</option>
            </select>
          </div>

          {/* Project filter */}
          <div>
            <label htmlFor="project" className="block text-sm font-medium text-gray-700 mb-1">
              Proyecto
            </label>
            <select
              id="project"
              name="project"
              value={filters.project}
              onChange={handleFilterChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="todos">Todos los proyectos</option>
              {uniqueProjects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>

          {/* Course filter */}
          <div>
            <label htmlFor="course" className="block text-sm font-medium text-gray-700 mb-1">
              Curso
            </label>
            <select
              id="course"
              name="course"
              value={filters.course}
              onChange={handleFilterChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="todos">Todos los cursos</option>
              {uniqueCourses.map((course) => (
                <option key={course} value={course}>
                  {course}
                </option>
              ))}
            </select>
          </div>

          {/* Status filter */}
          <div>
            <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1">
              Estado
            </label>
            <select
              id="status"
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="todos">Todos los estados</option>
              <option value="completada">Completada</option>
              <option value="en_progreso">En Progreso</option>
              <option value="pendiente">Pendiente</option>
            </select>
          </div>
        </div>
      </div>

      {/* Tabla de Evaluaciones */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">
            Lista de Evaluaciones ({filteredEvaluations.length})
          </h2>
          {filteredEvaluations.length > 0 && (
            <div className="text-sm text-gray-600">
              Mostrando {startIndex + 1} - {Math.min(endIndex, filteredEvaluations.length)} de {filteredEvaluations.length}
            </div>
          )}
        </div>

        {filteredEvaluations.length === 0 ? (
          <div className="p-8 text-center">
            <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
            </svg>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No hay evaluaciones</h3>
            <p className="text-gray-600">No se encontraron evaluaciones con los filtros seleccionados</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Proyecto
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Cursos
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Evaluación
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Tipo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Progreso
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Estado
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {paginatedEvaluations.map((evaluation) => {
                  const evaluationType = getEvaluationType(evaluation.type);
                  const progressPercentage = evaluation.totalStudents > 0
                    ? Math.round((evaluation.evaluatedStudents / evaluation.totalStudents) * 100)
                    : 0;
                  const configProgress = evaluation.totalIndicators > 0
                    ? Math.round((evaluation.configuredIndicators / evaluation.totalIndicators) * 100)
                    : 0;

                  return (
                    <tr
                      key={evaluation.id}
                      className="hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                      onClick={() => handleExecuteEvaluation(evaluation)}
                    >
                      <td className="px-6 py-4">
                        <div>
                          <div className="text-sm font-medium text-gray-900">
                            {evaluation.projectName}
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex flex-wrap gap-1">
                          {evaluation.courses && evaluation.courses.length > 0 ? (
                            evaluation.courses.map((course, index) => (
                              <span
                                key={index}
                                className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
                              >
                                {course}
                              </span>
                            ))
                          ) : (
                            <span className="text-sm text-gray-400">-</span>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div>
                          <div className="text-sm font-medium text-gray-900">
                            {evaluation.evaluationName}
                          </div>
                          {evaluation.teacherName && (
                            <div className="text-xs text-gray-500">
                              {evaluation.teacherName}
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${evaluationType.color}`}>
                          {evaluationType.label}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="space-y-2">
                          {/* Progreso de evaluación */}
                          <div>
                            <div className="flex justify-between text-xs text-gray-600 mb-1">
                              <span>Evaluados</span>
                              <span>{evaluation.evaluatedStudents}/{evaluation.totalStudents}</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div
                                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                                style={{ width: `${progressPercentage}%` }}
                              ></div>
                            </div>
                          </div>
                          {/* Progreso de configuración */}
                          <div>
                            <div className="flex justify-between text-xs text-gray-600 mb-1">
                              <span>Configuración</span>
                              <span>{evaluation.configuredIndicators}/{evaluation.totalIndicators}</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div
                                className="bg-green-600 h-2 rounded-full transition-all duration-300"
                                style={{ width: `${configProgress}%` }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {getStatusBadge(evaluation.status)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => handleExecuteEvaluation(evaluation)}
                            className="text-primary-600 hover:text-primary-900 inline-flex items-center"
                            title="Ejecutar evaluación"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                            </svg>
                          </button>
                          <button
                            onClick={() => handleConfigureEvaluation(evaluation)}
                            className="text-gray-600 hover:text-gray-900 inline-flex items-center"
                            title="Configurar evaluación"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => handleViewProject(evaluation.projectId)}
                            className="text-blue-600 hover:text-blue-900 inline-flex items-center"
                            title="Ver proyecto"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* Paginación */}
        {filteredEvaluations.length > 0 && (
          <div className="px-6 py-4 border-t border-gray-200">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="flex items-center justify-between sm:justify-start gap-4">
                <p className="text-sm text-gray-700">
                  Mostrando <span className="font-medium">{startIndex + 1}</span> a{' '}
                  <span className="font-medium">{Math.min(endIndex, filteredEvaluations.length)}</span> de{' '}
                  <span className="font-medium">{filteredEvaluations.length}</span> resultados
                </p>

                {/* Selector de items por página */}
                <div className="flex items-center space-x-2">
                  <label htmlFor="itemsPerPage" className="text-sm text-gray-700">
                    Por página:
                  </label>
                  <select
                    id="itemsPerPage"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    className="px-3 py-1 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>
              </div>

              {/* Controles de paginación */}
              <div className="flex items-center justify-center sm:justify-end space-x-2">
                {/* Botón Primera página */}
                <button
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                  className="px-3 py-1 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Primera página"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                  </svg>
                </button>

                {/* Botón Anterior */}
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-3 py-1 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Anterior
                </button>

                {/* Números de página */}
                <div className="flex items-center space-x-1">
                  {(() => {
                    const pages = [];
                    const maxVisiblePages = 5;
                    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

                    // Ajustar startPage si estamos cerca del final
                    if (endPage - startPage < maxVisiblePages - 1) {
                      startPage = Math.max(1, endPage - maxVisiblePages + 1);
                    }

                    // Botón de primera página con elipsis
                    if (startPage > 1) {
                      pages.push(
                        <button
                          key={1}
                          onClick={() => handlePageChange(1)}
                          className="px-3 py-1 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                          1
                        </button>
                      );
                      if (startPage > 2) {
                        pages.push(
                          <span key="ellipsis-start" className="px-2 py-1 text-gray-500">
                            ...
                          </span>
                        );
                      }
                    }

                    // Páginas visibles
                    for (let i = startPage; i <= endPage; i++) {
                      pages.push(
                        <button
                          key={i}
                          onClick={() => handlePageChange(i)}
                          className={`px-3 py-1 border rounded-lg text-sm font-medium transition-colors ${
                            currentPage === i
                              ? 'bg-primary-500 text-white border-primary-500'
                              : 'border-gray-300 text-gray-700 hover:bg-gray-50'
                          }`}
                        >
                          {i}
                        </button>
                      );
                    }

                    // Botón de última página con elipsis
                    if (endPage < totalPages) {
                      if (endPage < totalPages - 1) {
                        pages.push(
                          <span key="ellipsis-end" className="px-2 py-1 text-gray-500">
                            ...
                          </span>
                        );
                      }
                      pages.push(
                        <button
                          key={totalPages}
                          onClick={() => handlePageChange(totalPages)}
                          className="px-3 py-1 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                          {totalPages}
                        </button>
                      );
                    }

                    return pages;
                  })()}
                </div>

                {/* Botón Siguiente */}
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="px-3 py-1 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Siguiente
                </button>

                {/* Botón Última página */}
                <button
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                  className="px-3 py-1 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  title="Última página"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EvaluationList;